var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.0306 64.827C84.2854 63.821 85.7146 63.821 85.9694 64.827L86.3231 66.2234C87.6046 71.2827 91.7212 75.1285 96.8559 76.0634C97.8978 76.2531 97.8978 77.7469 96.8559 77.9366C91.7212 78.8715 87.6046 82.7173 86.3231 87.7766L85.9694 89.173C85.7146 90.179 84.2854 90.179 84.0306 89.173L83.6769 87.7766C82.3954 82.7173 78.2788 78.8715 73.1441 77.9366C72.1022 77.7469 72.1022 76.2531 73.1441 76.0634C78.2788 75.1285 82.3954 71.2827 83.6769 66.2234L84.0306 64.827Z",
    fill: "url(#paint0_linear_45185_10386)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M55.1757 53.7017C55.2567 53.3598 55.7433 53.3598 55.8243 53.7017L56.2373 55.4438C56.6667 57.2551 58.1314 58.638 59.9644 58.9626L61.1466 59.1719C61.5135 59.2369 61.5135 59.7634 61.1466 59.8284L59.9644 60.0378C58.1314 60.3624 56.6667 61.7452 56.2373 63.5565L55.8243 65.2986C55.7433 65.6405 55.2567 65.6405 55.1757 65.2986L54.7627 63.5565C54.3333 61.7452 52.8686 60.3624 51.0356 60.0378L49.8534 59.8284C49.4865 59.7634 49.4865 59.2369 49.8534 59.1719L51.0356 58.9626C52.8686 58.638 54.3333 57.2551 54.7627 55.4438L55.1757 53.7017Z",
    fill: "url(#paint1_linear_45185_10386)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_45185_10386",
    x1: 85,
    y1: 60.4839,
    x2: 85,
    y2: 93.5161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56DB53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1968B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_45185_10386",
    x1: 55.5,
    y1: 52.3335,
    x2: 55.5,
    y2: 66.6668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56DB53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1968B0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar4);
export default __webpack_public_path__ + "static/media/star-4.e1553ff6caa98f42a20f751a9315e4cf.svg";
export { ForwardRef as ReactComponent };